import { ApolloError } from "@apollo/client";

const loggedOutAuthCode = "AUTH_NOT_AUTHENTICATED";

type GraphQLErrorLike = {
  extensions?: {
    code?: unknown;
  } | null;
  path?: readonly (string | number)[] | null;
};

export function shouldSilenceLoggedOutMeError(input: {
  operationName?: string;
  graphQLErrors?: readonly GraphQLErrorLike[];
  networkError?: unknown;
}) {
  if (input.operationName !== "Me") {
    return false;
  }

  if (input.networkError) {
    return false;
  }

  const graphQLErrors = input.graphQLErrors ?? [];
  if (graphQLErrors.length === 0) {
    return false;
  }

  return graphQLErrors.every((error) => {
    const code = error.extensions?.code;
    const path = error.path;
    return (
      code === loggedOutAuthCode &&
      (!path || path.length === 0 || path[0] === "me")
    );
  });
}

export function isLoggedOutMeApolloError(error: unknown) {
  return (
    error instanceof ApolloError &&
    shouldSilenceLoggedOutMeError({
      operationName: "Me",
      graphQLErrors: error.graphQLErrors,
      networkError: error.networkError,
    })
  );
}
